import { useQuery } from "@tanstack/react-query";
import { BreakLine, BreakRule } from "@/shared/models/BreakRule";
import { getBreakRules } from "@/shared/repositories/BreakRuleRepository";

export const useBreakRules = (onError?: (error: Error) => void) =>
	useQuery<{ rules: BreakRule[]; lines: BreakLine[] }, Error>({
		queryKey: ["breakRules"],
		queryFn: () => getBreakRules(),
		onError,
		meta: { realtime: ["FAB.GetBreakRules"] },
	});
